import { ApolloCache } from '@apollo/client';
import { PutMediaMutation } from '@website/types/graphqlOperations';

/**
 * PutMedia Mutation Cache Update
 *
 * The apollo cache for the individual media item will be updated on a mutation,
 * but we also need to update the cache for the User/Host/Trip/Group where set.
 */
export function updateMediaCache(input: {
  cache: ApolloCache<any>;
  data: PutMediaMutation;
  groupID?: string;
  hostID?: string;
  tripID?: string;
  userID?: string;
}): void {
  const cacheTypes: string[] = ['Group', 'Host', 'Trip', 'User'];

  cacheTypes.forEach((cacheType) => {
    // Get the input ID name (e.g. userID) and ID (e.g. user_UUID)
    const inputIDName = `${cacheType.toLowerCase()}ID`;
    const inputID = input[inputIDName];

    // If the input ID was set, update the cache for this item
    if (inputID) {
      const { cache } = input;
      const cacheID = cache.identify({
        __typename: cacheType,
        id: inputID,
      });

      // Update the cache for each media item
      input.data.putMedia.forEach((media) => {
        const mediaCacheID = cache.identify({
          __typename: 'Media',
          id: media.id,
        });

        cache.modify({
          id: cacheID,
          fields: {
            media(cachedMedia) {
              const existingItems = cachedMedia.items || [];
              return {
                ...cachedMedia,
                // Put the new item before the existing ones
                items: [{ __ref: mediaCacheID }, ...existingItems],
              };
            },
          },
        });
      });
    }
  });
}
